/**
 * Etiquetas de los estados de un remito (`RemitoModel.status`), compartidas por
 * los reportes de producción (Excel, impresión y filtros).
 */
export const REMITO_STATUS_LABELS: Record<string, string> = {
  draft: 'Borrador',
  emitted: 'Emitido',
  printed: 'Impreso',
  canceled: 'Cancelado',
};
